export const siteName = "韩剧TV";

export const navItems = [
  { id: "install", label: "下载安装" },
  { id: "cache", label: "缓存视频" },
  { id: "offline", label: "离线观看" },
  { id: "versions", label: "版本下载" },
  { id: "storage", label: "存储画质" },
  { id: "genres", label: "剧集类型" },
  { id: "faq", label: "常见问题" },
];

export const heroChips = [
  { icon: "ri-android-line", text: "安卓版下载指引" },
  { icon: "ri-apple-line", text: "苹果版下载指引" },
  { icon: "ri-download-cloud-2-line", text: "缓存视频到手机" },
  { icon: "ri-flight-takeoff-line", text: "离线观看更省心" },
];

export const quickFeatures = [
  {
    id: "install",
    icon: "ri-download-2-line",
    title: "下载安装",
    desc: "分安卓与苹果两条路径，说明从获取安装包到完成安装的每一步，安装前要确认的系统与权限也都写清楚。",
    tag: "第一步",
  },
  {
    id: "cache",
    icon: "ri-download-cloud-2-line",
    title: "缓存视频",
    desc: "教你把想看的剧集按集缓存到本机：进入详情页、选择集数、挑选清晰度，再在下载列表里查看进度。",
    tag: "省流量",
  },
  {
    id: "offline",
    icon: "ri-flight-takeoff-line",
    title: "离线观看",
    desc: "缓存完成后即使没有网络也能打开播放，适合通勤、出差与网络不稳定时连续追剧，不需要现场缓冲。",
    tag: "无网可用",
  },
  {
    id: "phone",
    icon: "ri-smartphone-line",
    title: "下载到手机",
    desc: "从清晰度选择到存储空间规划，帮你把下载内容放在合适的位置，避免缓存到一半提示空间不足。",
    tag: "存储管理",
  },
];

export const installTabs = [
  {
    key: "android",
    label: "安卓版下载",
    icon: "ri-android-line",
    intro:
      "安卓设备通常通过安装包完成安装，过程灵活但也需要多留意系统安全提示，按下面步骤操作一般都能顺利完成。",
    steps: [
      "在本页的版本下载区点击“安卓版下载”，浏览器会开始获取安装包文件（.apk）。",
      "下拉手机通知栏或进入浏览器“下载”列表，确认安装包已经下载完成。",
      "点开安装包，若系统提示“未知来源应用”，进入 设置 → 安全 → 安装未知应用，找到当前浏览器并允许。",
      "按屏幕提示依次确认安装，等待进度走完后，桌面会出现韩剧TV 的应用图标。",
      "首次打开时按引导授予存储权限，方便之后把剧集缓存到手机本地。",
    ],
    notes: [
      "建议从可信渠道获取安装包，避免来源不明的文件。",
      "安装前确认剩余存储空间，空间不足会中断安装过程。",
      "如果安装被拦截，先关闭安全软件的一键拦截再重试安装。",
    ],
  },
  {
    key: "ios",
    label: "苹果版下载",
    icon: "ri-apple-line",
    intro:
      "iPhone 与 iPad 的安装方式更统一，主要通过应用商店完成，重点是核对应用信息与账号验证这两步。",
    steps: [
      "确认设备为 iPhone 或 iPad，并保证系统版本较新，避免打开应用时闪退。",
      "打开 App Store，在搜索框中输入“韩剧TV”并搜索。",
      "在结果列表中核对应用图标与开发者信息，避免点到名称相近的其他应用。",
      "点击“获取”，使用面容 / 触控 ID 或 Apple ID 密码完成验证。",
      "等待自动下载安装结束，回到主屏幕点击图标即可打开使用。",
    ],
    notes: [
      "下载过程中请保持网络稳定，避免中途中断。",
      "若无法获取，可先检查 Apple ID 的付款与地区设置。",
      "系统版本过旧时，部分新版应用可能无法安装。",
    ],
  },
];

export const cacheSteps = [
  {
    step: "01",
    title: "进入剧集详情页",
    desc: "打开韩剧TV，找到想看的韩剧，进入它的详情页，先确认总集数与更新状态。",
  },
  {
    step: "02",
    title: "选择要缓存的集数",
    desc: "在剧集列表中定位到具体某一集，可一次勾选多集，也能只挑下次想看的几集。",
  },
  {
    step: "03",
    title: "点击缓存按钮",
    desc: "点击每集旁的“下载 / 缓存”图标，图标会变为暂停或进度状态，表示任务已加入队列。",
  },
  {
    step: "04",
    title: "挑选清晰度档位",
    desc: "在弹出的清晰度选项中选标清、高清或超清，档位越高画质越好、占用空间也越大。",
  },
  {
    step: "05",
    title: "在下载列表查看进度",
    desc: "进入“我的 → 缓存 / 下载”可查看进度与已占用空间，完成后即可离线播放。",
  },
];

export const cacheTips = [
  "缓存前先确认手机剩余空间，避免下载到一半被迫中断。",
  "批量缓存多集时建议连接 Wi-Fi，减少移动流量消耗。",
  "缓存任务可以暂停与继续，切换网络后再恢复也不会丢进度。",
  "同一剧集只缓存想看的集数，比整季缓存更节省手机空间。",
];

export const offlinePoints = [
  {
    icon: "ri-wifi-off-line",
    title: "没有网络也能播放",
    desc: "已缓存的内容保存在手机本地，飞行模式或信号较弱时依然可以打开播放，不依赖实时缓冲。",
  },
  {
    icon: "ri-train-line",
    title: "通勤出差更从容",
    desc: "地铁、高铁、飞机等场景网络常常不稳定，提前缓存好剧集，路上就能连续追剧不卡顿。",
  },
  {
    icon: "ri-speed-up-line",
    title: "播放更稳定",
    desc: "本地文件读取不经过网络，拖动进度条、快进快退的响应更快，画质也相对稳定。",
  },
  {
    icon: "ri-database-2-line",
    title: "占用与清理可控",
    desc: "缓存会占用存储空间，看完的剧集可在下载列表里删除，及时释放空间给下一部剧。",
  },
];

export const versionColumns = [
  {
    id: "android",
    icon: "ri-android-line",
    title: "安卓版下载",
    subtitle: "Android 手机 / 平板",
    rows: [
      { label: "获取方式", value: "通过安装包（.apk）安装，也可在部分应用市场获取" },
      { label: "系统建议", value: "建议 Android 8.0 及以上，低版本可能无法打开" },
      { label: "安装提示", value: "首次安装可能需开启“允许安装未知应用”" },
      { label: "权限说明", value: "主要为存储权限，用于缓存视频到手机本地" },
      { label: "更新方式", value: "更新时通常覆盖安装，缓存内容一般不受影响" },
    ],
  },
  {
    id: "ios",
    icon: "ri-apple-line",
    title: "苹果版下载",
    subtitle: "iPhone / iPad",
    rows: [
      { label: "获取方式", value: "通过 App Store 搜索安装，流程最为统一" },
      { label: "系统建议", value: "建议较新的 iOS 版本，系统过旧可能无法安装" },
      { label: "安装提示", value: "需要 Apple ID 验证，可用面容 / 触控 ID 确认" },
      { label: "权限说明", value: "按系统引导授权存储与网络，用于缓存与播放" },
      { label: "更新方式", value: "在 App Store 的更新列表中完成升级" },
    ],
  },
];

export const qualityOptions = [
  {
    key: "sd",
    label: "标清 480P",
    res: "480P",
    size: "约 200–350MB / 集",
    scene: "流量或空间紧张，只想把剧情看完整",
    detail: "画面细节较少，适合小屏手机快速追剧，缓存速度最快、占用也最小。",
  },
  {
    key: "hd",
    label: "高清 720P",
    res: "720P",
    size: "约 350–600MB / 集",
    scene: "手机屏幕日常观看，清晰与体积比较均衡",
    detail: "大多数人推荐的档位，在手机上看已经足够清晰，同时不会太快吃满存储。",
  },
  {
    key: "fhd",
    label: "超清 1080P",
    res: "1080P",
    size: "约 700MB–1.2GB / 集",
    scene: "平板或大屏手机观看，更在意画质表现",
    detail: "细节与色彩表现更好，但单集占用明显变大，缓存前建议先确认剩余空间。",
  },
];

export const storageTips = [
  { icon: "ri-hard-drive-2-line", title: "先看剩余空间", desc: "缓存整季前先留出足够空间，通常比单集占用多出数倍。" },
  { icon: "ri-delete-bin-6-line", title: "定期清理已看内容", desc: "看完的剧集可在下载列表中删除，及时释放空间。" },
  { icon: "ri-folder-settings-line", title: "集中存放更好管理", desc: "若系统支持，可把缓存集中在同一位置，方便统一清理。" },
  { icon: "ri-battery-charge-line", title: "低电时避免批量下载", desc: "批量缓存较耗电，建议在电量充足或充电时进行。" },
];

export const genreFilters = [
  { key: "all", label: "全部" },
  { key: "romance", label: "浪漫爱情" },
  { key: "suspense", label: "悬疑推理" },
  { key: "historical", label: "古装历史" },
  { key: "workplace", label: "都市职场" },
  { key: "family", label: "家庭温情" },
];

export const genreCards = [
  {
    id: "g1",
    category: "romance",
    categoryLabel: "浪漫爱情",
    title: "甜宠浪漫剧",
    desc: "节奏轻松、单集情绪点密集，适合一次缓存多集在通勤路上连续观看，不需要刻意等更新。",
    fit: "通勤刷剧",
  },
  {
    id: "g2",
    category: "suspense",
    categoryLabel: "悬疑推理",
    title: "悬疑推理剧",
    desc: "剧情依赖前后伏笔，离线观看没有缓冲打断，更适合一口气看完某个案件段落，理清线索。",
    fit: "连续追案",
  },
  {
    id: "g3",
    category: "historical",
    categoryLabel: "古装历史",
    title: "古装历史剧",
    desc: "画面与服化道细节较多，用较高清晰度缓存更能看清场景与服饰，适合大屏观看。",
    fit: "高画质缓存",
  },
  {
    id: "g4",
    category: "workplace",
    categoryLabel: "都市职场",
    title: "都市职场剧",
    desc: "单集时长稳定、情节相对独立，很适合按天缓存一到两集，碎片时间看完不追不上进度。",
    fit: "碎片时间",
  },
  {
    id: "g5",
    category: "family",
    categoryLabel: "家庭温情",
    title: "家庭温情剧",
    desc: "节奏舒缓、适合睡前放松，缓存后免去广告与加载等待，观感更连贯，也方便回看。",
    fit: "睡前放松",
  },
  {
    id: "g6",
    category: "romance",
    categoryLabel: "浪漫爱情",
    title: "青春校园剧",
    desc: "篇幅通常较短、单集轻快，适合出差或旅途中整季缓存，路上一次看完不被打断。",
    fit: "旅途中追",
  },
  {
    id: "g7",
    category: "suspense",
    categoryLabel: "悬疑推理",
    title: "犯罪悬疑剧",
    desc: "氛围感强、需要专注，离线播放能减少消息弹窗外的干扰，把注意力留在剧情上。",
    fit: "沉浸观看",
  },
  {
    id: "g8",
    category: "historical",
    categoryLabel: "古装历史",
    title: "奇幻古装剧",
    desc: "特效与场景较多，建议连接 Wi-Fi 后以高清或超清缓存，画面表现更完整。",
    fit: "Wi-Fi 缓存",
  },
];

export const faqs = [
  {
    q: "韩剧TV 的安卓版和苹果版下载方式有什么不同？",
    a: "安卓版一般通过安装包（.apk）完成安装，过程中系统可能提示“允许安装未知应用”，需要手动放开权限；苹果版则统一在 App Store 搜索安装，用 Apple ID 验证即可。两者功能基本一致，差别主要在获取与安装路径上。",
  },
  {
    q: "“缓存视频”和“离线观看”是一回事吗？",
    a: "不完全是一回事。缓存视频是把剧集保存到手机本地的操作过程，离线观看则是缓存完成后的使用结果。先缓存，才有离线观看；如果只在线点开而没有缓存，断网后就无法继续播放。",
  },
  {
    q: "为什么缓存到手机后提示空间不足？",
    a: "清晰度越高、缓存的集数越多，占用空间就越大。整季缓存加上高清晰度很容易吃满存储，建议先查看剩余空间，或改用较低清晰度、只缓存想看的几集，也可以先清理看完的内容再继续。",
  },
  {
    q: "缓存好的剧集换一台手机还能看吗？",
    a: "缓存文件保存在原设备的本地存储里，一般不跟随账号自动转移到新设备。换机后需要在新的手机上重新缓存，才能在该设备上离线观看。",
  },
  {
    q: "下载安装时提示“未知来源”该怎么办？",
    a: "这是安卓系统的安全提示，不代表安装包有问题。可以在 设置 → 安全 → 安装未知应用 中找到当前使用的浏览器，临时允许安装，安装完成后再按需关闭该权限即可。",
  },
  {
    q: "缓存视频需要一直开着应用吗？",
    a: "不需要全程盯着屏幕，但建议在缓存任务进行期间保持应用在后台运行、且不要强制关闭。任务通常支持暂停与继续，切换网络后恢复一般不会丢失已有进度。",
  },
  {
    q: "手机存储里的缓存文件可以随便删除吗？",
    a: "可以在应用内的下载 / 缓存列表中删除已经看完的剧集，这是推荐的做法。不建议直接在文件管理器里随意删除，以免残留无效文件，导致下次缓存时出现显示异常。",
  },
];

export const footerLinks = [
  { id: "install", label: "下载安装指南" },
  { id: "cache", label: "缓存视频教程" },
  { id: "offline", label: "离线观看说明" },
  { id: "versions", label: "安卓版 / 苹果版" },
  { id: "storage", label: "存储与画质" },
  { id: "faq", label: "常见问题" },
];